define('constants/colorConstants',[], function() {
    return Object.freeze({
        colorPrimaryWhite: "#ffffff",
        colorSecondaryCool200: "#808795"
    });
});

